import API from './API.js'
import axios from 'axios'

export default class MediuEdu extends API {
  constructor() {
    super('MediuEdu')
  }
  async GetCourse() {
    const response = await axios.get('get-course');
    return response.data;
  }
  async GetCitizenship() {
    const response = await axios.get('get-citizenship');
    return response.data;
  }
  async GetRace() {
    const response = await axios.get('get-race');
    return response.data;
  }
  async GetReligion() {
    const response = await axios.get('get-religion');
    return response.data;
  }
  async GetEducationLevel() {
    const response = await axios.get('get-education-level');
    return response.data;
  }

  async GetYears(){
    const response = await axios.get('get-years');
    return response.data;
  }

}
